import { makeStyles } from '@material-ui/styles';
import React, { useState } from 'react';
import PropTypes, { questionPropType } from '../../helpers/propTypes';
import getAnswerComponent from '../Stepper/answer-types';
import ConsentText from './Text';

const useStyles = makeStyles((theme) => ({
  root: {
    // delimiter between individual consents (when more than one consent configured)
    '&:not(:last-child)': {
      marginBottom: '8px',
      paddingBottom: '8px',
      borderBottom: `solid ${theme.palette.grey[350]} 1px`,
    },
  },
}));

function ConsentItem({
  question: { id, question, description, type, items, options },
  answer,
  setAnswer,
  openTerms,
}) {
  const [metaData, setMetaData] = useState({});
  const classes = useStyles();
  const AnswerComponent = getAnswerComponent(type);

  return (
    <div data-testid="consent-answer" className={classes.root}>
      {type === 'yesno' && (
        <ConsentText openTerms={openTerms} terms={description}>
          {question}
        </ConsentText>
      )}

      <AnswerComponent
        clearAnswer={() => setAnswer(undefined)}
        currentAnswer={answer}
        fullWidth
        itemId={id}
        items={items}
        meta={metaData}
        options={options}
        setAnswer={setAnswer}
        setMeta={(key, value) => setMetaData({ ...metaData, [key]: value })}
        question={question}
        description={description}
        openTerms={openTerms}
      />
    </div>
  );
}

ConsentItem.propTypes = {
  answer: PropTypes.string,
  openTerms: PropTypes.func.isRequired,
  question: questionPropType.isRequired,
  setAnswer: PropTypes.func.isRequired,
};

ConsentItem.defaultProps = {
  answer: undefined,
};

export default ConsentItem;
